import { render, staticRenderFns } from "./WagonDepartureExecutionViewPanel.vue?vue&type=template&id=615c491e&scoped=true"
import script from "./WagonDepartureExecutionViewPanel.vue?vue&type=script&lang=js"
export * from "./WagonDepartureExecutionViewPanel.vue?vue&type=script&lang=js"
import style0 from "./WagonDepartureExecutionViewPanel.vue?vue&type=style&index=0&id=615c491e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c491e",
  null
  
)

export default component.exports